function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12.3989,
  cy: 11.6143,
  r: 11,
  stroke: "#083261"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0447 9.10485H13.5407V17.7129H11.0447V9.10485ZM12.2927 7.90485C11.8341 7.90485 11.4607 7.77152 11.1727 7.50485C10.8847 7.23818 10.7407 6.90752 10.7407 6.51285C10.7407 6.11818 10.8847 5.78752 11.1727 5.52085C11.4607 5.25418 11.8341 5.12085 12.2927 5.12085C12.7514 5.12085 13.1247 5.24885 13.4127 5.50485C13.7007 5.76085 13.8447 6.08085 13.8447 6.46485C13.8447 6.88085 13.7007 7.22752 13.4127 7.50485C13.1247 7.77152 12.7514 7.90485 12.2927 7.90485Z",
  fill: "#083261"
});

var SvgExclamationMark = function SvgExclamationMark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExclamationMark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/exclamation-mark.aafb667e.svg";
export { ForwardRef as ReactComponent };